export default {
  title: "Sub-Industria"
  , form: {
    descripcion: {
      label: "Descripción"
      , th: "Descripción"
    }
  }
  , errors: {
    BD5017: { text: "Ocurrió un error en el catálogo de Sub-Industria" }
    , WS5017: { text: "Ocurrió un error en el catálogo de Sub-Industria" }
    , JS5017: { text: "Ocurrió un error en el catálogo de Sub-Industria" }
    , CR5017: { text: "Ocurrió un error en el catálogo de Sub-Industria" }
    , UK_SubIndustria: { text: "Ya existe un registro con la misma descripción" }
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/operativos/subindustria.js